import { Box, Group, Stack, Text } from "@mantine/core"
import {
  CheckCircleIcon,
  WarningIcon,
  XCircleIcon,
} from "@phosphor-icons/react"
import type { CheckRow } from "./assign-checks"

interface Props {
  checks: CheckRow[]
}

function Icon({ status }: { status: CheckRow["status"] }) {
  if (status === "pass")
    return <CheckCircleIcon size={14} weight="fill" color="var(--mantine-color-green-7)" />
  if (status === "warn")
    return <WarningIcon size={14} weight="fill" color="var(--mantine-color-yellow-7)" />
  return <XCircleIcon size={14} weight="fill" color="var(--mantine-color-red-7)" />
}

function textColor(status: CheckRow["status"]): string {
  if (status === "pass") return "green.7"
  if (status === "warn") return "yellow.8"
  return "red.7"
}

export function AssignValidationChecks({ checks }: Props) {
  return (
    <Box
      p="sm"
      style={{
        border: "1px solid var(--mantine-color-gray-2)",
        borderRadius: "var(--mantine-radius-md)",
      }}
    >
      <Text size="sm" c="dimmed" fw={700} tt="uppercase" mb="xs">
        Шалгалт
      </Text>
      <Stack gap={4}>
        {checks.map((c) => (
          <Group key={c.key} justify="space-between" gap="xs">
            <Group gap={6} align="center">
              <Icon status={c.status} />
              <Text size="sm" fw={600} c={textColor(c.status)}>
                {c.label}
              </Text>
            </Group>
            {c.detail && (
              <Text size="sm" c="dimmed">
                {c.detail}
              </Text>
            )}
          </Group>
        ))}
      </Stack>
    </Box>
  )
}
